"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationReact = exports.Location = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _store = require("../../store");
var _ToolTip = require("../tooltip/ToolTip");
var _constants = require("../../store/constants");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var KEYCODE_ENTER = 13;
var LocationReact = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(LocationReact, _React$Component);
  var _super = _createSuper(LocationReact);
  function LocationReact() {
    var _this;
    (0, _classCallCheck2.default)(this, LocationReact);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateFieldInfo", function (event) {
      event.persist();
      if (event.currentTarget.type === 'text') {
        if (event.keyCode === KEYCODE_ENTER) {
          _this.searchProvider();
        } else {
          _this.props.updateSearchField('location', event.currentTarget.value);
        }
      }
    });
    return _this;
  }
  (0, _createClass2.default)(LocationReact, [{
    key: "searchProvider",
    value: function searchProvider() {
      var search = this.props.search;
      if (search.location || search.name) {
        this.props.fireSearch(_constants.PENDING);
        this.props.fireSearch(_constants.COMPLETE);
        this.props.updateSyncedState();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var inputClass = 'location-input';
      var inputPlaceHolder = 'Zip Code or City';
      var selectSpecialtyText = 'Select a specialty first';
      var id = 'location';
      var renderInputField = function renderInputField(tooltipMessage) {
        var _this$props = this.props,
          search = _this$props.search,
          siteInfo = _this$props.siteInfo;
        var tooltipProps = {
          className: inputClass,
          message: tooltipMessage,
          field: 'input',
          placeholder: inputPlaceHolder,
          id: id
        };
        if (search.specialty === '') {
          tooltipProps.className = 'location-input disabled';
          if (!siteInfo.redux) {
            return /*#__PURE__*/_react.default.createElement(_ToolTip.ToolTipReact, tooltipProps);
          }
          return /*#__PURE__*/_react.default.createElement(_ToolTip.ToolTip, tooltipProps);
        }
        return /*#__PURE__*/_react.default.createElement("input", {
          type: "text",
          id: id,
          onKeyDown: this.updateFieldInfo,
          onChange: this.updateFieldInfo,
          placeholder: inputPlaceHolder,
          className: inputClass
        });
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "location"
      }, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: id,
        className: "location-text"
      }, "Location"), renderInputField.call(this, selectSpecialtyText));
    }
  }]);
  return LocationReact;
}(_react.default.Component);
exports.LocationReact = LocationReact;
var mapStateToProps = function mapStateToProps(state) {
  return {
    search: state.search,
    siteInfo: state.siteInfo
  };
};
LocationReact.propTypes = {
  siteInfo: _propTypes.default.object.isRequired,
  search: _propTypes.default.object,
  fireSearch: _propTypes.default.func,
  updateSyncedState: _propTypes.default.func,
  updateSearchField: _propTypes.default.func
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_objectSpread({}, _store.actions), dispatch);
};
var Location = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LocationReact);
exports.Location = Location;
